import { render, staticRenderFns } from "./EngineFaultsDetails.vue?vue&type=template&id=71be7570&scoped=true&"
import script from "./EngineFaultsDetails.vue?vue&type=script&lang=js&"
export * from "./EngineFaultsDetails.vue?vue&type=script&lang=js&"
import style1 from "./EngineFaultsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be7570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout,VRadio,VRadioGroup})
